/**
 * @file Anything that can run on every page
 */
import svg4everybody from 'svg4everybody';
import anime from 'animejs/lib/anime.es.js';

// ResizeEnd Event
jQuery( window ).on( 'resize', function() {
	if ( this.resizeTO ) {
		clearTimeout( this.resizeTO );
	}
	this.resizeTO = setTimeout( function() {
		jQuery( this ).trigger( 'resizeEnd' );
	}, 200 );
} );

jQuery( function( $ ) {
	// Mobile nav code
	const myBox   = $( '#menu' );
	const myNav   = $( '#menu ul li' );
	let navHeight = 0;

	$( '#hamburger' ).click( function() {
		if ( myBox.hasClass( 'close' ) ) {
			myBox.removeClass( 'close' );
		}

		myBox.addClass( 'open' );
		myNav.addClass( 'open' );

		navHeight = Math.round( $( '#menu ul' ).height() );

		// Center menu on screen
		const windowHeight = $( window ).height();
		const windowWidth  = $( window ).width();
		const deskOffset   = ( windowHeight - navHeight ) / 1.25;
		const mobileOffset = ( windowHeight - navHeight ) / 1.5;

		if ( windowWidth > 736 ) {
			$( '#menu ul' ).css( 'padding-top', deskOffset + 'px' );
		} else {
			$( '#menu ul' ).css( 'padding-top', mobileOffset + 'px' );
		}
	} );

	$( '#closeme' ).on( 'click', function() {
		myNav.addClass( 'close' );
		myBox.addClass( 'close' );

		if ( myBox.hasClass( 'open' ) ) {
			setTimeout( function() {
				myBox.removeClass( 'open' );
			}, 500 );
		}
	} );

	// Search bar code
	const searchBox = $( '#searchbox' );

	$( '.cssanimations .search-btn' ).on( 'click', function() {
		if ( searchBox.is( ':visible' ) ) {
			searchBox.addClass( 'close' );
			searchBox.one( 'webkitAnimationEnd oanimationend msAnimationEnd animationend',
				function() {
					searchBox.removeClass( 'open' );
					searchBox.removeClass( 'close' );
				} );
		}

		if ( searchBox.is( ':hidden' ) ) {
			searchBox.addClass( 'open' );
			searchBox.one( 'webkitAnimationEnd oanimationend msAnimationEnd animationend',
				function() {
					searchBox.removeClass( 'close' );
				} );
		}
	} );

	$( '#searchbox span' ).on( 'click', function() {
		$( '#searchbox input[type="submit"]' ).trigger( 'click' );
	} );

	// Worker for map module on footer
	let isOpen        = false;
	const windowWidth = $( window ).width();

	/**
	 *
	 */
	function footerClassToggle() {
		const isMobileFooter = matchMedia( '(max-width: 980px)' );

		if ( isMobileFooter.matches ) {
			$( '.m-locations__content-list--wrapper' )
				.addClass( 'm-locations__content-list--mobile' );
			if ( ! isOpen ) {
				toggleLocations();
			}
		} else {
			$( '.m-locations__content-list--wrapper' )
				.removeClass( 'm-locations__content-list--mobile' );
		}
	}

	footerClassToggle();

	$( window ).on( 'resize', function() {
		if ( $( window ).width !== windowWidth ) {
			footerClassToggle();
		}
	} );

	/**
	 *
	 */
	function toggleLocations() {
		const list = $( '.m-locations__content-list--mobile' )[ 0 ];

		if ( ! list ) {
			return;
		}

		const plusSign = $( '.m-locations__plus-icon--vertical' )[ 0 ];

		list.style.display = 'block';
		const listHeight   = list.scrollHeight;

		if ( ! isOpen ) {
			plusSign.style.display = 'none';

			const toggleOn = anime.timeline( {
				easing:   'easeOutSine',
				autoplay: false,
				duration: 500,
			} );

			toggleOn.add( {
				targets:      list,
				maxHeight:    listHeight,
				opacity:      [ 0, 1 ],
				marginBottom: [ 0, '2rem' ],
				duration:     400,
			} );

			toggleOn.play();
		} else {
			plusSign.style.display = 'block';

			const toggleOff = anime.timeline( {
				easing:   'easeOutSine',
				autoplay: false,
				duration: 500,
			} );

			toggleOff.add( {
				targets:      list,
				maxHeight:    0,
				opacity:      [ 1, 0 ],
				marginBottom: [ '2rem', 0 ],
				duration:     400,
				complete() {
					list.removeAttribute( 'style' );
				},
			} );

			toggleOff.play();
		}

		isOpen = ! isOpen;
	}

	$( '#locations-btn' ).on( 'click', toggleLocations );

	// Prevent Default on links on Services pages that don't have featured projects
	$( '.page-id-56 #featured-work a, .page-id-58 #featured-work a' ).on( 'click', function( event ) {
		event.preventDefault();
	} );

	// Searchbox focus state icon color
	$( '#searchbox input.search-field' ).on( 'focus', function() {
		$( '#searchbox span' ).css( 'color', '#fff' );
	} );

	$( '#searchbox input.search-field' ).on( 'focusout', function() {
		$( '#searchbox span' ).css( 'color', '#5094a0' );
	} );

	// IE9 Functionality
	$( '.no-cssanimations .search-btn' ).on( 'click', function() {
		searchBox.toggleClass( 'open' );
	} );
} ); //END Document Ready

jQuery( window ).load( function() {
	svg4everybody();

	//Set project sidenav prev / next height
	const prevNextHeight = $( '#side-nav .prev-next' ).find( 'img' ).height();
	$( '#side-nav .prev-next' ).css( 'height', prevNextHeight );

	$( '#mobile-nav h3' ).on( 'click', function() {
		if ( $( '#mobile-menu' ).hasClass( 'open' ) ) {
			$( '#mobile-menu' ).slideToggle( '1500', 'swing', function() {
				$( '#mobile-menu' ).removeClass( 'open' );
			} );
		} else {
			$( '#mobile-menu' ).slideToggle( '1500', 'swing', function() {
				$( '#mobile-menu' ).addClass( 'open' );
			} );
		}
	} );

	$( '.form-mobile p span.button' ).on( 'click', function() {
		if ( $( '.form-mobile .form-fields' ).hasClass( 'open' ) ) {
			$( '.form-mobile .form-fields' ).slideToggle( '1500', 'swing', function() {
				$( '.form-mobile .form-fields' ).removeClass( 'open' );
			} );
		} else {
			$( '.form-mobile .form-fields' ).slideToggle( '1500', 'swing', function() {
				$( '.form-mobile .form-fields' ).addClass( 'open' );
			} );
		}
	} );
} );

jQuery( window ).on( 'resize', function() {
	//Resize project sidebar prev / next height
	const prevNextResize = jQuery( '#side-nav .prev-next' ).find( 'img' ).height();
	jQuery( '#side-nav .prev-next' ).css( 'height', prevNextResize );
} ); // END Window Resize

